import { type FC, forwardRef } from 'react';
import classNames from 'classnames/bind';
import { Theme } from '../../types/enums';
import type { BubbleNotificationPropType, BubbleNotificationTheme } from './types/propsType';
import styles from './BubbleNotification.module.scss';

const cx = classNames.bind(styles);

const BubbleNotification: FC<BubbleNotificationPropType> = forwardRef<HTMLDivElement, BubbleNotificationPropType>(
  ({ message, messageCount, theme = Theme.SUCCESS, className = '', ...restProps }, ref) => {
    const CClassname = cx('bubble-container', [theme], className);
    return (
      <div className={CClassname} {...restProps} data-testid="bubble-test-id" ref={ref}>
        <span className={`${styles['messageCount']}`}>{`${messageCount}`}</span>
        <span className={`${styles['message']}`}>{`${message}`}</span>
      </div>
    );
  },
);
BubbleNotification.displayName = 'BubbleNotification';

export default BubbleNotification;
export type { BubbleNotificationTheme };
